import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { TopupBalanceForm } from '@/features/consumer/topup-balance-form';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(consumer)/_authenticated/my-wallet/topup-balance'
)({
  component: TopupBalancePage,
});

function TopupBalancePage() {
  const navigate = useNavigate();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => navigate({ to: '/my-wallet' })}
        />
        <HeaderDashboard.Title>Topup Balance</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <TopupBalanceForm />
      </div>
    </div>
  );
}
